export default {"src":"/_next/static/media/partnership.7c22e744.svg","height":20,"width":20};